import { getActivityFeedSettings } from '../service/getActivityFeedSettings';
import { setActivityFeedSettings } from '../actions/setActivityFeedSettings';
import loadActivityFeed from './loadActivityFeed';
import { getActivityFeedSettingsStore } from '../store/notificationSettingStore';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    ActivityFeedSettingIds,
    SettingIdsToActivityTypeMapping,
} from '../service/ActivityFeedSettingType';
import type { ActivityFeedSettingsResponse } from '../service/ActivityFeedSettingType';
import { trace } from 'owa-trace';

let activityFeedSettingPromise: Promise<ActivityFeedSettingsResponse>;

export async function loadActivityFeedSettings(
    doLoadActivityFeed: boolean
): Promise<ActivityFeedSettingsResponse> {
    if (activityFeedSettingPromise) {
        return activityFeedSettingPromise;
    }
    activityFeedSettingPromise = getActivityFeedSettings();
    activityFeedSettingPromise
        .then(value => {
            if (value && value[0].name === 'notification_settings') {
                try {
                    const setting = JSON.parse(value[0].value) as { [key: number]: boolean };
                    setActivityFeedSettings(setting);
                    if (doLoadActivityFeed) {
                        loadActivityFeed();
                    }
                } catch {
                    trace.warn('Failed to parse Activity feed settings');
                }
            }
        })
        .catch(function (err) {
            trace.warn('Failed to load activity feed settings ' + err.message);
            // We should load activity feed with default options as the settings failed to load.
            if (doLoadActivityFeed) {
                loadActivityFeed();
            }
        });
    return activityFeedSettingPromise;
}

export async function getFilter(): Promise<string[]> {
    let typesToExclude: string[] = [];
    if (!activityFeedSettingPromise) {
        trace.info('Loading ActivityFeedSettings before initializeActivityFeed.');
        await loadActivityFeedSettings(false /* doLoadActivityFeed */);
    }

    getActivityFeedSettingsStore().forEach((value, key) => {
        if (
            !value ||
            (isFeatureEnabled('rp-reactions') && key === ActivityFeedSettingIds.likeNotification)
        ) {
            SettingIdsToActivityTypeMapping.get(key).forEach(Id =>
                typesToExclude.push(Id.toString())
            );
        }
    });
    return typesToExclude;
}
